module.exports = __webpack_public_path__ + "static/media/022.48d8e1e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/022.jpg
// module id = 495
// module chunks = 0